import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Button from '../Parts/Button';
import Typography from 'material-ui/Typography'
import Setting from '../Icons/Setting'
import Human from '../Icons/Human';
import Building from '../Icons/Building';
import Section from '../common/Section';
import SubmenuSection from '../common/SubmenuSection';
import Submenu from '../common/Submenu';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import Checkbox from 'material-ui/Checkbox';
import MenuItem from 'material-ui/Menu/MenuItem';
import CorporationDepartmentTelControl from './controls/CorporationDepartmentTelControl';
import CallAnalysisControl from './controls/CallAnalysisControl';
import DailyNotificationControl from './controls/DailyNotificationControl';
import KLOperatorAdvancedSearchControl from './controls/KLOperatorAdvancedSearchControl';
import IsIncludeConsolidatedControl from './controls/IsIncludeConsolidatedControl';
import GenericKeywordSearchControl from './controls/GenericKeywordSearchControl';
import AttackListGeneratorControl from './controls/AttackListGeneratorControl';
import ExeSearchNoMatchDialog from './dialogs/ExeSearchNoMatchDialog';
import ConfirmExeSearchDialog from './dialogs/ConfirmExeSearchDialog';
import SelectCapSizeFilterDialog from './dialogs/SelectCapSizeFilterDialog';
import DateRangePickerDialog from '../common/DateRangePickerDialog';
import HelpIcon from "../Icons/HelpIcon";
import ArrowToolTip from "../common/ArrowToolTip";
import { SentDateRangeDialogType, CorporationSentDateRangeDialogType, FollowCallOrderDateRangeDialogType } from "../../constants/ComponentTypes";
import { flattenMap, generateCapSizePerCorporationMenu } from '../../utils/utils';
import { isVisibleFilter } from '../../utils/executiveListAuthorityUtils';
import { isEnableReactionKeyword } from '../../utils/userUtils';
import { generateRelocationMenu } from '../../utils/utils'
import { isEnableSearchExeByCorpNumbers } from '../../utils/userUtils'
import { isFreePlan } from '../../utils/planUtils';
import { compressSelectionToNodes } from '../../utils/treeUtils';
import {
  DAILY_NOTIFICATION_FILTER_CONFIG,
  KEYWORD_SEARCH_CONFIG,
  KEYWORD_SEARCH_IS_AND_CONFIG,
  USER_LIST_FILTER_CONFIG,
  KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG,
  HIERARCHICAL_MENU_CONFIG, MAP_MENU_CONFIG,
  CORPORATION_RELATIONSHIPS_CONFIG,
  CORPORATION_RELATIONSHIPS_LABEL_CONFIG,
  SIMPLE_MENU_FILTER_CONFIG,
  FUNDRAISING_FILTER_CONFIG,
  INDUSTRY_SEARCH_MODE_CONFIG,
  generateConfigInitialState
} from '../../constants/ExecutiveListSearchKeyConstants';

import {
  statusMenu,
  sentStatusMenu,
  corporationSentStatusMenu,
  followCallOrderStatusMenu,
  downloadStatusMenu,
  honorificNestedMenu,
  departmentNestedMenu,
  investBusinessAreaNestedMenu,
  webToolNestedMenu,
  corporationStatisticsChangeNestedMenu,
  excludeRetirementMenu,
  prefectureNameMenu,
  jsicMenu, // 旧式の業界ダイアログ 旧式の業界ダイアログを利用している顧客がいるため削除できない
  capSortMenu,
  // dummyMenuForTitleNew, ※タイトルに対して子のオプションがない「表示する人数を制限」等は子と連動してタイトルにNEWラベルをつけることができないのでダミーのメニューを作成していた。現在は不要なので、コメントアウトしている
} from '../../constants/SidebarValues';
import { ERR_READ_FILE } from '../../constants/ErrorMessages'
import { addCommas } from '../../utils/utils';
import { SHEET_JSFT } from '../../constants/Constants'
import XLSX from 'xlsx';
import Encoding from 'encoding-japanese';
const { Set, Map, OrderedSet } = require('immutable');

const styles = () => ({
  container: {
    width: '100%',
    height: '100%',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'hidden',
  },

  title: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    boxSizing: 'border-box',
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    background: '#FFFFFF',
    padding: '25px 20px',
    marginBottom: '2px',
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  content: {
    overflowY: 'scroll',
    padding: '10px 25px 80px 25px',
    width: '100%',
    boxSizing: 'border-box',
  },

  bottomMenuContainer: {
    width: "100%",
    position: 'absolute',
    bottom: 0,
  },

  bottomMenu: {
    width: "100%",
    height: "80px",
    minHeight: "60px",
    transition: 'transform 0.3s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
    background: '#FFFFFF',
    boxShadow: '11px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    color: "#181819",
    padding: '0px 35px',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },

  select: {
    fontSize: '14px',
    minWidth: '240px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '8px 12px',
    textAlign: 'left',
    boxSizing: 'border-box',
  },

  sectionHeader: {
    marginBottom: '12px',
  },

  sectionBody: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    marginTop: 0,
  },

  editFilter: {
    color: '#71737B',
    textDecoration: 'underline',
    cursor: 'pointer',
    flex: 1,
  },

  exeSearchHead: {
    margin: '10px 0',
    fontSize: '11px',
    color: '#5A5B62',
    display: 'block',
  },

  exeSearch: {
    border: '1px solid #D8DBDF',
    marginTop: '15px',
    width: '100%',
    boxSizing: 'border-box',
    background: '#FAFAFA',
  },

  exeSearchDesc: {
    width: '100%',
    padding: '5px 15px 15px 15px',
    fontSize: '11px',
    color: '#181819',
    boxSizing: 'border-box',
  },

  exeSearchDescPoint: {
    marginTop: '10px',
    display: 'block',
  },

  img: {
    width: '100%',
  },

  input: {
    display: 'none',
  },

  selectedListNames: {
    border: '1px solid #6F9EFF',
    marginTop: '15px',
    width: '100%',
    boxSizing: 'border-box',
    background: '#F2F6FF',
    fontSize: '11px',
    color: '#1A65FF',
    padding: '5px 15px 15px 15px',
  },

  line: {
    textOverflow: 'ellipsis',
    width: '100%',
    margin: '10px 0 0 0',
    boxSizing: 'border-box',
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },

  label: {
    margin: '10px 0px 35px 0px',
    boxSizing: 'border-box',
    background: '#1A65FF',
    padding: '13px',
    color: '#5A5B62',
    fontSize: '13px',
    fontWeight: 'bold',
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
  },

  entry: {
    width: '100%',
    marginTop: '8px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  text: {
    marginLeft: '5px',
    fontSize: '14px',
    cursor: 'pointer',
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    marginTop: "10px",
  },

  arrowClass: {
    position: "absolute",
    fontSize: 6,
    bottom: 0,
    left: "calc(34% - 1.5em)",
    marginBottom: "-0.95em",
    width: "3em",
    height: "1em",

    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
      borderWidth: "1em 1em 0 1em",
      borderColor: `#181819 transparent transparent transparent`,
    },
  },
});

// 着任
const relocationAtMenu = generateRelocationMenu();
const capSizePerCorporationMenu = generateCapSizePerCorporationMenu();

class ExecListSidebar extends React.Component {
  initialState = {
    cap_size_per_corporation: "0",
    cap_sort_first_preferred: "0",
    cap_sort_second_preferred: "0",
    cap_priority: Set(),
    timeline_status: Map(),
    relocation_at: Map(),
    exclude_retirement: [true].toString(), //デフォルト値は「退任した人を含めない」
    exclude_retirement_risk: false,
    corporate_number: OrderedSet(),
    company_name: OrderedSet(),
    sent_status: Map(),
    sent_only_from: '',
    sent_only_to: '',
    sent_except_from: '',
    sent_except_to: '',
    corporation_sent_status: Map(),
    corporation_sent_only_from: '',
    corporation_sent_only_to: '',
    corporation_sent_except_from: '',
    corporation_sent_except_to: '',
    download_status: Map(),
    follow_call_order_status: Map(),
    follow_call_order_only_from: '',
    follow_call_order_only_to: '',
    follow_call_order_except_from: '',
    follow_call_order_except_to: '',
    exclude_registered_address: false,
    unique_per_corporation: false,
    show_recently_created: false,
    show_yesterday_created: false,
    exists_corporation_department_tels_filter: false,
    include_field_call_analysis_ids: false,
    showExeSearchNoMatchDialog: false,
    showConfirmExeSearchDialog: false,
    showSelectCapSizeFilterDialog: false,
    showSentDateRangePickerDialog: false,
    showCorporationSentDateRangePickerDialog: false,
    showFollowCallOrderDateRangePickerDialog: false,
    dateRangePickerDialogType: null,
    companys: null,
    isCorporateNumber: false,
    is_include_consolidated_search_number_of_employees: true,
    // 各設定から動的に生成された初期状態を追加
    ...generateConfigInitialState(HIERARCHICAL_MENU_CONFIG, { includeDialogState: true}),
    ...generateConfigInitialState(MAP_MENU_CONFIG, { includeDialogState: true}),
    ...generateConfigInitialState(USER_LIST_FILTER_CONFIG),
    ...generateConfigInitialState(KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG),
    ...generateConfigInitialState(KEYWORD_SEARCH_CONFIG, { includeShowKeywordTextfieldState: true }),
    ...generateConfigInitialState(KEYWORD_SEARCH_IS_AND_CONFIG),
    ...generateConfigInitialState(CORPORATION_RELATIONSHIPS_CONFIG),
    ...generateConfigInitialState(CORPORATION_RELATIONSHIPS_LABEL_CONFIG),
    ...generateConfigInitialState(DAILY_NOTIFICATION_FILTER_CONFIG),
    ...generateConfigInitialState(SIMPLE_MENU_FILTER_CONFIG),
    ...generateConfigInitialState(FUNDRAISING_FILTER_CONFIG),
    ...generateConfigInitialState(INDUSTRY_SEARCH_MODE_CONFIG),
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentWillMount() {
    this.setState({
      ...this.props.filterValue,
      companys: null,
      isCorporateNumber: false,
    });
  }

  componentWillUnmount() {
    if (this.contentRef) {
      this.contentRef.removeEventListener('keydown', this.handleEnterKeyPressed);
      this.contentRef.removeEventListener('scroll', this.handleScroll);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.isEqual(this.props.filterValue, nextProps.filterValue)) {
      this.setState({
        ...nextProps.filterValue,
        companys: null,
        isCorporateNumber: false,
      });
    }
  }

  toggleExeSearchNoMatchDialog = () => {
    this.setState({ showExeSearchNoMatchDialog: !this.state.showExeSearchNoMatchDialog });
  }

  toggleConfirmExeSearchDialog = (companys, isCorporateNumber = false) => {
    this.setState({
      showConfirmExeSearchDialog: !this.state.showConfirmExeSearchDialog,
      companys: companys,
      isCorporateNumber: isCorporateNumber,
    });
  }

  toggleSelectCapSizeFilterDialog = () => {
    this.setState({ showSelectCapSizeFilterDialog: !this.state.showSelectCapSizeFilterDialog });
  }

  toggleSentDateRangePickerDialog = (type = null) => {
    let dialogType = type;
    if (type) {
      dialogType = type === '注文済みキーマンのみを表示' ? SentDateRangeDialogType.SENT_ONLY : SentDateRangeDialogType.SENT_EXCEPT;
    }
    this.setState({
      showSentDateRangePickerDialog: !this.state.showSentDateRangePickerDialog,
      dateRangePickerDialogType: dialogType,
    });
  }

  toggleCorporationSentDateRangePickerDialog = (type = null) => {
    let dialogType = type;
    if (type) {
      dialogType = type === '注文済み企業のみを表示' ? CorporationSentDateRangeDialogType.CORPORATION_SENT_ONLY : CorporationSentDateRangeDialogType.CORPORATION_SENT_EXCEPT;
    }
    this.setState({
      showCorporationSentDateRangePickerDialog: !this.state.showCorporationSentDateRangePickerDialog,
      dateRangePickerDialogType: dialogType,
    });
  }

  toggleFollowCallOrderDateRangePickerDialog = (type = null) => {
    let dialogType = type;
    if (type) {
      dialogType = type === 'フォローコール依頼済みのみを表示' ? FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY : FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_EXCEPT;
    }
    this.setState({
      showFollowCallOrderDateRangePickerDialog: !this.state.showFollowCallOrderDateRangePickerDialog,
      dateRangePickerDialogType: dialogType,
    });
  }

  toggleExcludeTextField = (property) => () => {
    this.setState({ [property]: !this.state[property] });
  }

  toggleHierarchicalMenuDialog = (config) => () => {
    this.setState(prevState => ({
      [config.dialogShowStateKey]: !prevState[config.dialogShowStateKey]
    }));
  }

  deselectAll = (property) => () => {
    this.setState({
      [property]: this.initialState[property],
    })
  }

  selectAll = (property, menuItems) => () => {
    // 初期値の型をチェック
    const initialValue = this.initialState[property];
    const isMap = Map.isMap(initialValue);

    if (isMap) {
      let map = Map();

      if (menuItems) {
        menuItems.forEach(item => {
          let set = Set();
          item.submenu.forEach(menuItem => {
            set = set.add(menuItem.value);
          })
          map = map.set(item.value, set);
        })

        this.setState({
          [property]: map,
        })
      }
    } else {
      let set = Set();

      if (menuItems) {
        menuItems.forEach(item => {
          set = set.add((item.id || item.value).toString());
        })

        this.setState({
          [property]: set,
        })
      }
    }
  }

  handleSave = (property) => (value) => {
    this.setState({
      [property]: value,
    })
  }

  handleDataRangeFilterSet = (filter, dialogType) => {
    const {
      // 注文済みキーマンの日付範囲選択の場合
      sent_only_from,
      sent_only_to,
      sent_except_from,
      sent_except_to,
      // 注文済み企業の日付範囲選択の場合
      corporation_sent_only_from,
      corporation_sent_only_to,
      corporation_sent_except_from,
      corporation_sent_except_to,
      // フォローコール依頼済みの日付範囲選択の場合
      follow_call_order_only_from,
      follow_call_order_only_to,
      follow_call_order_except_from,
      follow_call_order_except_to
    } = this.state;
    let itemValue = '';
    let state = {};
    let parent, menu, property;

    if (dialogType.includes('corporation_sent')) {
      // 注文済みキーマンの日付範囲選択の場合
      parent = this.state.corporation_sent_status;
      menu = corporationSentStatusMenu;
      property = 'corporation_sent_status';

      // 注文済み企業のみの日付範囲選択の場合
      if (
        filter &&
        filter.corporation_sent_only_from &&
        filter.corporation_sent_only_to &&
        (corporation_sent_only_from !== filter.corporation_sent_only_from || corporation_sent_only_to !== filter.corporation_sent_only_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済み企業のみを表示').value;
      }

      // 注文済み企業除外の日付範囲選択の場合
      if (
        filter &&
        filter.corporation_sent_except_from &&
        filter.corporation_sent_except_to &&
        (corporation_sent_except_from !== filter.corporation_sent_except_from || corporation_sent_except_to !== filter.corporation_sent_except_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済み企業を除外').value;
      }
    } else if (dialogType.includes('sent')) {
      // 注文済みキーマンの日付範囲選択の場合
      parent = this.state.sent_status;
      menu = sentStatusMenu;
      property = 'sent_status';

      // 注文済みキーマンのみの日付範囲選択の場合
      if (
        filter &&
        filter.sent_only_from &&
        filter.sent_only_to &&
        (sent_only_from !== filter.sent_only_from || sent_only_to !== filter.sent_only_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済みキーマンのみを表示').value;
      }

      // 注文済みキーマン除外の日付範囲選択の場合
      if (
        filter &&
        filter.sent_except_from &&
        filter.sent_except_to &&
        (sent_except_from !== filter.sent_except_from || sent_except_to !== filter.sent_except_to)
      ) {
        itemValue = menu.find(item => item.name === '注文済みキーマンを除外').value;
      }
    } else if (dialogType.includes('follow_call_order')) {
      // フォローコール依頼済みの日付範囲選択の場合
      parent = this.state.follow_call_order_status;
      menu = followCallOrderStatusMenu;
      property = 'follow_call_order_status';

      // 日付範囲が選択された場合
      if (filter && filter.follow_call_order_only_from && filter.follow_call_order_only_to &&
        (follow_call_order_only_from !== filter.follow_call_order_only_from || follow_call_order_only_to !== filter.follow_call_order_only_to)
      ) {
        itemValue = menu.find(item => item.name === 'フォローコール依頼済みのみを表示').value;
      }
      if (filter && filter.follow_call_order_except_from && filter.follow_call_order_except_to &&
        (follow_call_order_except_from !== filter.follow_call_order_except_from || follow_call_order_except_to !== filter.follow_call_order_except_to)
      ) {
        itemValue = menu.find(item => item.name === 'フォローコール依頼済みを除外').value;
      }
    }

    if (itemValue) {
      // 日付範囲が選択された場合で絞り込みオプションにチェックボックスにされていない場合はチェックする
      if (!this.state[property].has(itemValue)) {
        let submenu = Set();
        let entry = menu.find(item => item.value === itemValue);
        if (entry) {
          entry.submenu.forEach(item => {
            submenu = submenu.add(item.value);
          })
        }
        parent = parent.set(itemValue, submenu);
        state = {
          [property]: parent,
        };
      }
      this.setState({ ...filter, ...state })
    }
  }

  handleSelectParent = (property, menu) => value => {
    let parent = this.state[property];
    let state = {};

    if (parent) {
      if (parent.has(value)) {
        parent = parent.delete(value);
        state = {
          [property]: parent,
        };
        // 送信ステータスのチェックが外された場合は日付範囲も削除する
        if (property === 'sent_status') {
          const name = menu.find(item => item.value === value).name
          let startDate, endDate;
          if (name === '注文済みキーマンのみを表示') {
            startDate = 'sent_only_from';
            endDate = 'sent_only_to';
          } else if (name === '注文済みキーマンを除外') {
            startDate = 'sent_except_from';
            endDate = 'sent_except_to';
          }
          state[startDate] = '';
          state[endDate] = '';
        }

        // 企業送信ステータスのチェックが外された場合は日付範囲も削除する
        if (property === 'corporation_sent_status') {
          const name = menu.find(item => item.value === value).name
          let startDate, endDate;
          if (name === '注文済み企業のみを表示') {
            startDate = 'corporation_sent_only_from';
            endDate = 'corporation_sent_only_to';
          } else if (name === '注文済み企業を除外') {
            startDate = 'corporation_sent_except_from';
            endDate = 'corporation_sent_except_to';
          }
          state[startDate] = '';
          state[endDate] = '';
        }

        // フォローコール依頼済みのチェックが外された場合は日付範囲も削除する
        if (property === 'follow_call_order_status') {
          const name = menu.find(item => item.value === value).name;
          let startDate, endDate;
          if (name === 'フォローコール依頼済みのみを表示') {
            startDate = 'follow_call_order_only_from';
            endDate = 'follow_call_order_only_to';
          } else if (name === 'フォローコール依頼済みを除外') {
            startDate = 'follow_call_order_except_from';
            endDate = 'follow_call_order_except_to';
          }
          state[startDate] = '';
          state[endDate] = '';
        }
      } else {
        let submenu = Set();
        let entry = menu.find(item => item.value === value);

        if (entry) {
          if (entry.isSubmenuSingleSelect) {
            entry.submenu.forEach(item => {
              if (item.default === true) {
                submenu = submenu.add(item.value);
              }
            })
          } else {
            entry.submenu.forEach(item => {
              submenu = submenu.add(item.value);
            })
          }
        }

        parent = parent.set(value, submenu);
        state = {
          [property]: parent,
        };
      }
      this.setState(state)
    }
  }

  handleSelectChild = (property) => (parentValue, childValue) => {
    let parent = this.state[property];
    let children = parent.get(parentValue);
    let state = {};

    if (childValue === undefined || !children) {
      children = Set();
    }

    if (children) {
      if (children.has(childValue)) {
        children = children.delete(childValue);
      } else {
        children = children.add(childValue);
      }
    }

    if (children.size === 0) {
      parent = parent.delete(parentValue);
      state = {
        [property]: parent,
      };
      // 送信ステータスのチェックが外された場合は日付範囲も削除する
      if (property === 'sent_status') {
        const name = sentStatusMenu.find(item => item.value === parentValue).name
        let startDate, endDate;
        if (name === '注文済みキーマンのみを表示') {
          startDate = 'sent_only_from';
          endDate = 'sent_only_to';
        } else if (name === '注文済みキーマンを除外') {
          startDate = 'sent_except_from';
          endDate = 'sent_except_to';
        }
        state[startDate] = '';
        state[endDate] = '';
      }
      if (property === 'corporation_sent_status') {
        const name = sentStatusMenu.find(item => item.value === parentValue).name
        let startDate, endDate;
        if (name === '注文済み企業を表示') {
          startDate = 'corporation_sent_only_from';
          endDate = 'corporation_sent_only_to';
        } else if (name === '注文済み企業を除外') {
          startDate = 'corporation_sent_except_from';
          endDate = 'corporation_sent_except_to';
        }
        state[startDate] = '';
        state[endDate] = '';
      }
      // フォローコール依頼済みのチェックが外された場合は日付範囲も削除する
      if (property === 'follow_call_order_status') {
        const name = followCallOrderStatusMenu.find(item => item.value === parentValue).name;
        let startDate, endDate;
        if (name === 'フォローコール依頼済みのみを表示') {
          startDate = 'follow_call_order_only_from';
          endDate = 'follow_call_order_only_to';
        } else if (name === 'フォローコール依頼済みを除外') {
          startDate = 'follow_call_order_except_from';
          endDate = 'follow_call_order_except_to';
        }
        state[startDate] = '';
        state[endDate] = '';
      }
    } else {
      parent = parent.set(parentValue, children);
      state = {
        [property]: parent,
      };
    }

    this.setState(state);
  }

  handleSelectChildSingleSelect = (property) => (parentValue, childValue) => {
    let parent = this.state[property];
    let children = Set();

    children = children.add(childValue);
    parent = parent.set(parentValue, children);

    this.setState({
      [property]: parent,
    })
  }

  handleSelect = property => value => {
    if (this.state.hasOwnProperty(property)) {
      let set = this.state[property];
      if (set.includes(value)) {
        this.setState({
          [property]: set.delete(value),
        })
      } else {
        this.setState({
          [property]: set.add(value),
        })
      }
    }
  }

  handleReset = () => {
    this.setState(this.initialState)
  }

  handleChange = (property) => e => {
    this.setState({
      [property]: e.target.value,
    })
  }

  handleKeymanFilterChange = (property, value) => {
    this.setState({
      [property]: value,
    })
  }

  handleCheck = (property) => () => {
    this.setState({
      [property]: !this.state[property],
    })
  }

  handleClick = () => {
    // MAP_MENU_CONFIGからdialogShowStateKeyを取得
    const mapMenuDialogStateKeys = Object.values(MAP_MENU_CONFIG)
      .filter(config => config.dialogShowStateKey)
      .map(config => config.dialogShowStateKey);
    // HIERARCHICAL_MENU_CONFIGからdialogShowStateKeyを取得
    const hierarchicalDialogStateKeys = Object.values(HIERARCHICAL_MENU_CONFIG)
      .filter(config => config.dialogShowStateKey)
      .map(dialog => dialog.dialogShowStateKey);
    // KEYWORD_SEARCH_CONFIGからshowKeywordTextfieldStateKeyを取得
    const keywordSearchShowKeywordTextfieldStateKeys = Object.values(KEYWORD_SEARCH_CONFIG)
      .filter(config => config.showKeywordTextfieldStateKey)
      .map(config => config.showKeywordTextfieldStateKey);

    // 他の除外したいstateキー todo 追加漏れが発生する可能性があるので、NESTED_MENU_DIALOGSのようにグループ分けして管理したい。
    const otherStateKeys = [
      'showExeSearchNoMatchDialog',
      'showConfirmExeSearchDialog',
      'companys',
      'isCorporateNumber',
      'showSelectCapSizeFilterDialog',
      'showSentDateRangePickerDialog',
      'showCorporationSentDateRangePickerDialog',
      'showFollowCallOrderDateRangePickerDialog',
      'dateRangePickerDialogType',
    ];

    // 全ての除外するキーを結合
    const excludeKeys = [
      ...mapMenuDialogStateKeys,
      ...hierarchicalDialogStateKeys,
      ...keywordSearchShowKeywordTextfieldStateKeys,
      ...otherStateKeys
    ];

    // stateから除外キーを除いたfilterValueを作成
    const filterValue = Object.fromEntries(
      Object.entries(this.state).filter(([key]) => !excludeKeys.includes(key))
    );

    this.props.updateFilter(filterValue);
  }

  handleRadioChange = (property, judgeValue) => (e) => {
    this.setState({
      [property]: e.target.value === judgeValue,
    });
  }

  handleUploadClick = () => {
    const { user } = this.props;
    if (isEnableSearchExeByCorpNumbers(user)) {
      this.fileUpload.click();
    } else {
      this.props.togglePlanDialog();
    }
  };

  handleSetCompanys = () => {
    if (this.state.companys) {
      let { corporate_number, company_name } = this.state.companys;
      let corporateNumberArr = [], companyNameArr = [];

      if (this.state.isCorporateNumber) {
        corporate_number.forEach((item, i) => {
          if (item) {
            corporateNumberArr.push(item);
          } else if (company_name && company_name[i]) {
            companyNameArr.push(company_name[i]);
          }
        });
      } else {
        companyNameArr = company_name.filter(item => !!item);
      }

      this.setState({
        corporate_number: OrderedSet(corporateNumberArr),
        company_name: OrderedSet(companyNameArr),
      })
    } else {
      this.setState({
        corporate_number: OrderedSet(),
        company_name: OrderedSet(),
      })
    }
  }

  handleClickPlanDialogByUserPlan = (isEnable) => {
    const { user } = this.props;
    const isFree = isFreePlan(user);

    if (isFree) {
      this.props.togglePlanDialog();
    } else if (!isEnable) {
      this.props.togglePromotePlanChangeDialog();
    }
  }

  // Excelの数値セルとして読み込まれた法人番号が指数表記(例: 1.23457E+12)にならないよう文字列へ変換する
  normalizeCorporateNumber = (value) => {
    if (value === null || value === undefined) {
      return '';
    }

    // 数値で読み込まれた場合、指数表記を避けるため整数文字列へ変換する
    if (typeof value === 'number') {
      return Number.isInteger(value) ? value.toFixed(0) : String(value);
    }

    return String(value).trim();
  };

  handleFile = (event) => {
    const reader = new FileReader();

    const files = event.target.files;
    if (files && files[0]) {
      reader.fileName = files[0].name;
      reader.file = files[0];
      reader.readAsArrayBuffer(files[0]);

      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        let wb;

        // ファイルの読み取りができるか
        try {
          wb = XLSX.read(bstr, { type: 'array', sheetRows: 0 })
        } catch (e) {
          this.props.displayNotification(ERR_READ_FILE, "error");
          return;
        }
        const sheet = Object.values(wb.Sheets)[0];

        // 列名を抽出する
        let corporateNumCol, companyNameCol, header = [];

        // 「法人番号」の列を抽出する
        for (let key in sheet) {
          if (key.match(/^[A-Z]*1$/g)) {
            let columnName = sheet[key].v;
            const encodingType = Encoding.detect(columnName);
            if (encodingType !== 'UNICODE') {
              columnName = Encoding.convert(columnName, {
                to: 'UNICODE',
                from: encodingType,
              });
            }

            if (/法人番号/g.test(columnName)) {
              corporateNumCol = columnName;
            }

            if (/組織名|会社名|企業名|company/g.test(columnName)) {
              companyNameCol = columnName;
            }

            header.push(columnName);
          }
        }

        if (corporateNumCol === undefined && companyNameCol === undefined) {
          this.toggleExeSearchNoMatchDialog();
        } else {
          // raw: true で書式化済みの値(.w)ではなく生の値を取得する。
          // これにより数値の法人番号が指数表記の文字列に変換されてしまうのを防ぐ。
          const data = XLSX.utils.sheet_to_json(sheet, { header: header, raw: true });
          let companyData = {};

          if (corporateNumCol !== undefined) {
            companyData['corporate_number'] = data.slice(1).map(item => this.normalizeCorporateNumber(item[corporateNumCol]))
          }

          if (companyNameCol !== undefined) {
            companyData['company_name'] = data.slice(1).map(item => {
              let company_name = item[companyNameCol];
              // raw: true により数値で読み込まれる場合があるため文字列へ揃える
              if (company_name === null || company_name === undefined) {
                return '';
              }
              if (typeof company_name !== 'string') {
                return String(company_name);
              }
              const encodingType = Encoding.detect(company_name);
              if (encodingType !== 'UNICODE') {
                company_name = Encoding.convert(company_name, {
                  to: 'UNICODE',
                  from: encodingType,
                });
              }
              return company_name;
            })
          }

          this.toggleConfirmExeSearchDialog(companyData, corporateNumCol !== undefined);
        }
      };
    }
  };

  handleScroll = () => {
    const maxScrollTop = 20;
    if (this.contentRef && this.titleRef && this.contentRef.scrollTop > maxScrollTop) {
      this.titleRef.style.boxShadow = '0px 1px 10px 0px rgba(0, 0, 0, 0.12)';
    } else {
      this.titleRef.style.boxShadow = 'none'
    }
  }

  handleEnterKeyPressed = (e) => {
    const enterKeyCode = 13;
    if (e.keyCode === enterKeyCode && this.hasSelection(this.props.filterValue)) {
      this.handleClick()
    }
  }

  setContentRef = (node) => {
    this.contentRef = node;
    if (this.contentRef) {
      this.contentRef.addEventListener('keydown', this.handleEnterKeyPressed, false);
      this.contentRef.addEventListener('scroll', this.handleScroll, false);
    }
  }

  setTitleRef = (node) => {
    this.titleRef = node;
  }

  hasSelection = (filterValue) => {
    // 設定オブジェクトから動的に比較対象のプロパティを取得
    const configProperties = [
      ...Object.values(HIERARCHICAL_MENU_CONFIG).map(config => config.key),
      ...Object.values(MAP_MENU_CONFIG).map(config => config.key),
      ...Object.values(USER_LIST_FILTER_CONFIG).map(config => config.key),
      ...Object.values(KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG).map(config => config.key),
      ...Object.values(KEYWORD_SEARCH_CONFIG).map(config => config.key),
      ...Object.values(KEYWORD_SEARCH_IS_AND_CONFIG).map(config => config.key),
      ...Object.values(DAILY_NOTIFICATION_FILTER_CONFIG).map(config => config.key),
      ...Object.values(SIMPLE_MENU_FILTER_CONFIG).map(config => config.property),
      ...Object.values(FUNDRAISING_FILTER_CONFIG).map(config => config.key),
      ...Object.values(INDUSTRY_SEARCH_MODE_CONFIG).map(config => config.key),
    ];

    // 設定オブジェクトのプロパティを動的に比較
    const configPropertyDifferences = configProperties.some(property => {
      const stateValue = this.state[property];
      const filterValueProp = filterValue[property];

      // Immutableオブジェクトの場合はequalsメソッドを使用
      if (stateValue && typeof stateValue.equals === 'function') {
        return !stateValue.equals(filterValueProp);
      }
      // プリミティブ値の場合は直接比較
      return stateValue !== filterValueProp;
    });

    // その他の手動で定義された項目の比較
    const otherDifferences = (
      !this.state.relocation_at.equals(filterValue.relocation_at) ||
      !this.state.corporate_number.equals(filterValue.corporate_number) ||
      !this.state.company_name.equals(filterValue.company_name) ||
      this.state.exclude_retirement !== filterValue.exclude_retirement ||
      this.state.exclude_retirement_risk !== filterValue.exclude_retirement_risk ||
      !this.state.timeline_status.equals(filterValue.timeline_status) ||
      !this.state.sent_status.equals(filterValue.sent_status) ||
      !this.state.corporation_sent_status.equals(filterValue.corporation_sent_status) ||
      !this.state.follow_call_order_status.equals(filterValue.follow_call_order_status) ||
      !this.state.download_status.equals(filterValue.download_status) ||
      this.state.sent_only_from !== filterValue.sent_only_from ||
      this.state.sent_only_to !== filterValue.sent_only_to ||
      this.state.sent_except_from !== filterValue.sent_except_from ||
      this.state.sent_except_to !== filterValue.sent_except_to ||
      this.state.corporation_sent_only_from !== filterValue.corporation_sent_only_from ||
      this.state.corporation_sent_only_to !== filterValue.corporation_sent_only_to ||
      this.state.corporation_sent_except_from !== filterValue.corporation_sent_except_from ||
      this.state.corporation_sent_except_to !== filterValue.corporation_sent_except_to ||
      this.state.follow_call_order_only_from !== filterValue.follow_call_order_only_from ||
      this.state.follow_call_order_only_to !== filterValue.follow_call_order_only_to ||
      this.state.follow_call_order_except_from !== filterValue.follow_call_order_except_from ||
      this.state.follow_call_order_except_to !== filterValue.follow_call_order_except_to ||
      this.state.exclude_registered_address !== filterValue.exclude_registered_address ||
      this.state.unique_per_corporation !== filterValue.unique_per_corporation ||
      this.state.show_recently_created !== filterValue.show_recently_created ||
      this.state.show_yesterday_created !== filterValue.show_yesterday_created ||
      this.state.exists_corporation_department_tels_filter !== filterValue.exists_corporation_department_tels_filter ||
      this.state.include_field_call_analysis_ids !== filterValue.include_field_call_analysis_ids ||
      this.state.is_include_consolidated_search_number_of_employees !== filterValue.is_include_consolidated_search_number_of_employees ||
      this.state.cap_size_per_corporation !== filterValue.cap_size_per_corporation ||
      this.state.cap_sort_first_preferred !== filterValue.cap_sort_first_preferred ||
      this.state.cap_sort_second_preferred !== filterValue.cap_sort_second_preferred
    );

    return configPropertyDifferences || otherDifferences;
  }

  isEqual = (curr, next) => {
    if (!!curr && !!next) {
      let currVals = Object.values(curr);
      let nextVals = Object.values(next);

      if (currVals.length !== nextVals.length) return false;

      let equal = true;

      currVals.forEach((currItem, i) => {
        if (typeof currItem === 'string') {
          equal = equal && (currItem === nextVals[i]);
        } else if (typeof currItem === 'boolean') {
          equal = equal && (currItem === nextVals[i]);
        } else {
          if (currItem) {
            equal = equal && (currItem.equals(nextVals[i]));
          }
        }
      })

      return equal;
    }

    return false;
  }

  renderExeSearchNoMatchDialog = () => (
    <ExeSearchNoMatchDialog
      isOpen={this.state.showExeSearchNoMatchDialog}
      toggleDialog={this.toggleExeSearchNoMatchDialog}
    />
  )

  renderConfirmExeSearchDialog = () => (
    <ConfirmExeSearchDialog
      isOpen={this.state.showConfirmExeSearchDialog}
      toggleDialog={this.toggleConfirmExeSearchDialog}
      companys={this.state.companys}
      confirm={this.handleSetCompanys}
    />
  )

  renderSelectCapSizeFilterDialog = () => (
    <SelectCapSizeFilterDialog
      isOpen={this.state.showSelectCapSizeFilterDialog}
      toggleDialog={this.toggleSelectCapSizeFilterDialog}
      saveCapSizePerCorporation={this.handleSave('cap_size_per_corporation')}
      savaCapSortFirstPreferred={this.handleSave('cap_sort_first_preferred')}
      savaCapSortSecondPreferred={this.handleSave('cap_sort_second_preferred')}
      set_cap_size_per_corporation={this.state.cap_size_per_corporation}
      set_cap_sort_first_preferred={this.state.cap_sort_first_preferred}
      set_cap_sort_second_preferred={this.state.cap_sort_second_preferred}
    />
  )

  renderSentDateRangePickerDialog = () => {
    const { dateRangePickerDialogType, sent_only_from, sent_only_to, sent_except_from, sent_except_to } = this.state;

    if (this.state.showSentDateRangePickerDialog) {
      return (
        <DateRangePickerDialog
          isOpen={this.state.showSentDateRangePickerDialog}
          toggleDialog={this.toggleSentDateRangePickerDialog}
          dialogType={dateRangePickerDialogType}
          dataRangeFilterSet={this.handleDataRangeFilterSet}
          user={this.props.user}
          orderList={this.props.letterOrderList}
          title={'注文日で絞り込み'}
          from={dateRangePickerDialogType === SentDateRangeDialogType.SENT_ONLY ? sent_only_from : sent_except_from}
          to={dateRangePickerDialogType === SentDateRangeDialogType.SENT_ONLY ? sent_only_to : sent_except_to}
          isExe={true}
        />
      )
    }
  }

  renderCorporationSentDateRangePickerDialog = () => {
    const { dateRangePickerDialogType, corporation_sent_only_from, corporation_sent_only_to, corporation_sent_except_from, corporation_sent_except_to } = this.state;

    if (this.state.showCorporationSentDateRangePickerDialog) {
      return (
        <DateRangePickerDialog
          isOpen={this.state.showCorporationSentDateRangePickerDialog}
          toggleDialog={this.toggleCorporationSentDateRangePickerDialog}
          dialogType={dateRangePickerDialogType}
          dataRangeFilterSet={this.handleDataRangeFilterSet}
          user={this.props.user}
          orderList={this.props.letterOrderList}
          title={'注文日で絞り込み'}
          from={dateRangePickerDialogType === CorporationSentDateRangeDialogType.CORPORATION_SENT_ONLY ? corporation_sent_only_from : corporation_sent_except_from}
          to={dateRangePickerDialogType === CorporationSentDateRangeDialogType.CORPORATION_SENT_ONLY ? corporation_sent_only_to : corporation_sent_except_to}
          isExe={true}
        />
      )
    }
  }

  renderFollowCallOrderDateRangePickerDialog = () => {
    const { dateRangePickerDialogType, follow_call_order_only_from, follow_call_order_only_to, follow_call_order_except_from, follow_call_order_except_to } = this.state;

    if (this.state.showFollowCallOrderDateRangePickerDialog) {
      return (
        <DateRangePickerDialog
          isOpen={this.state.showFollowCallOrderDateRangePickerDialog}
          toggleDialog={this.toggleFollowCallOrderDateRangePickerDialog}
          dialogType={dateRangePickerDialogType}
          dataRangeFilterSet={this.handleDataRangeFilterSet}
          user={this.props.user}
          orderList={this.props.followCallOrderList}
          title={'注文日で絞り込み'}
          from={dateRangePickerDialogType === FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY ? follow_call_order_only_from : follow_call_order_except_from}
          to={dateRangePickerDialogType === FollowCallOrderDateRangeDialogType.FOLLOW_CALL_ORDER_ONLY ? follow_call_order_only_to : follow_call_order_except_to}
          isExe={true}
        />
      )
    }
  }

  renderCompany = () => {
    const { classes, disabled } = this.props;
    let names = this.state.company_name.toArray().concat(this.state.corporate_number.toArray());
    const displayItemCount = 5;
    if (names.length > 0) {
      return (
        <div
          className={classes.selectedListNames}
          style={{
            color: disabled ? '#B1B3B9' : '#1A65FF',
            background: disabled ? '#FAFAFA' : '#F2F6FF',
            borderColor: disabled ? '#D8DBDF' : '#6F9EFF',
          }}>
          {names.slice(0, displayItemCount).map((c, i) => (
            <p key={i} className={classes.line} title={c}>・{c}</p>
          ))}

          {names.length > displayItemCount && (
            <p style={{ marginTop: 13 }} className={classes.line}>…他{addCommas(names.length - displayItemCount)}件の項目</p>
          )}
        </div>
      )
    }

    return undefined;
  }

  renderFundraisingFilter = (config, disabled) => {
    const { classes } = this.props;
    const { key, type, menu, sidebarLabel, tooltip } = config;

    if (type === 'select') {
      return (
        <div key={key} style={{ marginBottom: '12px' }}>
          <Typography variant="body2" style={{ marginBottom: '4px', color: '#71737B', fontSize: '12px' }}>
            {sidebarLabel}
          </Typography>
          <FormControl fullWidth>
            <Select
              value={this.state[key]}
              onChange={this.handleChange(key)}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                }
              }}
              classes={{ select: classes.select }}
              disabled={disabled}
              fullWidth
              disableUnderline
              displayEmpty
            >
              {menu.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
      );
    }

    if (type === 'set') {
      return (
        <div key={key} style={{ marginBottom: '12px' }}>
          <Typography variant="body2" style={{ marginBottom: '4px', color: '#71737B', fontSize: '12px' }}>
            {sidebarLabel}
          </Typography>
          {menu.map((item) => (
            <div
              key={item.value}
              className={classes.entry}
              onClick={() => this.handleSelect(key)(item.value)}
              style={{ marginBottom: '4px' }}
            >
              <Checkbox
                color="primary"
                checked={this.state[key].has(item.value)}
                onChange={() => this.handleSelect(key)(item.value)}
                style={{ width: '20px', height: '20px' }}
                disabled={disabled}
              />
              <Typography className={classes.text} variant="body2" style={{ color: disabled ? '#B1B3B9' : '#181819' }}>
                {item.name}
              </Typography>
            </div>
          ))}
        </div>
      );
    }

    if (type === 'boolean') {
      return (
        <div key={key} style={{ marginBottom: '12px' }}>
          <div
            className={classes.entry}
            onClick={this.handleCheck(key)}
            style={{ marginBottom: '4px' }}
          >
            <Checkbox
              color="primary"
              checked={this.state[key]}
              onChange={this.handleCheck(key)}
              style={{ width: '20px', height: '20px' }}
              disabled={disabled}
            />
            <Typography className={classes.text} variant="body2" style={{ color: disabled ? '#B1B3B9' : '#181819' }}>
              {sidebarLabel}
            </Typography>
            {tooltip && (
              <ArrowToolTip
                text={tooltip}
                arrowClass={classes.arrowClass}
                style={{ marginLeft: '2px' }}
              >
                <HelpIcon width={16} height={16} color="#71737B" />
              </ArrowToolTip>
            )}
          </div>
        </div>
      );
    }

    return null;
  }

  renderNestedList = (property, menu) => {
    const { classes, disabled } = this.props;

    let items = flattenMap(this.state[property], menu, property === 'jsic' ? 'value' : 'name');
    const displayItemCount = 5;
    if (items.length > 0) {
      return (
        <div
          className={classes.selectedListNames}
          style={{
            color: disabled ? '#B1B3B9' : '#1A65FF',
            background: disabled ? '#FAFAFA' : '#F2F6FF',
            borderColor: disabled ? '#D8DBDF' : '#6F9EFF',
          }}>
          {items.slice(0, displayItemCount).map((item, i) => (
            <p key={i} className={classes.line} title={item}>・{item}</p>
          ))}

          {items.length > displayItemCount && (
            <p style={{ marginTop: 13 }} className={classes.line}>…他{addCommas(items.length - displayItemCount)}件の項目</p>
          )}
        </div>
      )
    }

    return undefined;
  }

  renderHierarchicalMenuList = (config) => {
    const { classes, disabled } = this.props;

    const selectedItems = compressSelectionToNodes(this.props[config.menuListKey], this.state[config.property]);

    const displayItemCount = 5;
    if (selectedItems.length > 0) {
      return (
        <div
          className={classes.selectedListNames}
          style={{
            color: disabled ? '#B1B3B9' : '#1A65FF',
            background: disabled ? '#FAFAFA' : '#F2F6FF',
            borderColor: disabled ? '#D8DBDF' : '#6F9EFF',
          }}>
          {selectedItems.slice(0, displayItemCount).map((item, i) => (
            <p key={i} className={classes.line} title={item.name}>・{item.name}</p>
          ))}

          {selectedItems.length > displayItemCount && (
            <p style={{ marginTop: 13 }} className={classes.line}>…他{addCommas(selectedItems.length - displayItemCount)}件の項目</p>
          )}
        </div>
      )
    }

    return undefined;
  }

  renderHierarchicalMenuDialog = (config) => {
    if (!this.state[config.dialogShowStateKey]) return null;

    const Component = config.component;
    const extraProps = {};

    // 追加プロパティがある場合は設定
    if (config && config.extraProps) {
      config.extraProps.forEach(prop => {
        extraProps[prop] = this.props[prop];
      });
    }

    // hierarchicalMenuが必要な場合のみ追加
    if (config && config.menuListKey) {
      extraProps.hierarchicalMenu = this.props[config.menuListKey];
    }

    // 業種選択ダイアログの場合は検索モードを渡す
    if (config.key === 'industry_minor_category_ids') {
      extraProps.industrySearchMode = this.state.industry_search_mode;
      extraProps.onSearchModeChange = (mode) => this.handleKeymanFilterChange('industry_search_mode', mode);
    }

    return (
      <Component
        key={config.key}
        isOpen={this.state[config.dialogShowStateKey]}
        toggleDialog={this.toggleHierarchicalMenuDialog(config)}
        save={this.handleSave(config.property)}
        set={this.state[config.property]}
        {...extraProps}
      />
    );
  }

  renderCapSizeFilter = () => {
    const { classes, disabled } = this.props;

    let filters = [
      { property: 'cap_size_per_corporation', menu: capSizePerCorporationMenu },
      { property: 'cap_sort_first_preferred', menu: capSortMenu },
      { property: 'cap_sort_second_preferred', menu: capSortMenu },
    ];

    if (Object.values(filters[0].menu).find(target => this.state[filters[0].property] === target.value)) {
      return (
        <div
          className={classes.selectedListNames}
          style={{
            color: disabled ? '#B1B3B9' : '#1A65FF',
            background: disabled ? '#FAFAFA' : '#F2F6FF',
            borderColor: disabled ? '#D8DBDF' : '#6F9EFF',
          }}>
          {(() => {
            return (
              filters.map((filter, i) => {
                const target = Object.values(filter.menu).find(target => this.state[filter.property] === target.value);
                if (filter.property === 'cap_size_per_corporation') {
                  return (<p className={classes.line} key={i}>・{target.name}</p>);
                } else {
                  if (target.value === '0') {
                    return null;
                  } else {
                    const prefix = filter.property === 'cap_sort_first_preferred' ? '第一優先' : '第二優先'
                    return (<p className={classes.line} key={i}>・{prefix} {target.name}</p>);
                  }
                }
              })
            )
          })()}
        </div>
      )
    }
  }

  render() {
    const { classes, disabled, filters, selectedFilter, user } = this.props;

    return (
      <div className={classes.container} style={{ pointerEvents: disabled ? 'none' : 'auto' }}>
        <div className={classes.title} ref={this.setTitleRef}>
          <Setting height={15} width={15} color="#B1B3B9" style={{ marginRight: '10px' }} />
          <Typography variant="subheading" style={{ color: disabled ? '#B1B3B9' : '#181819', flex: 1 }}>
            複数条件で絞り込む
          </Typography>

          {(() => {
            if (this.hasSelection(this.initialState)) {
              return (
                <Button
                  text="リセット"
                  type="ghost"
                  size="extra-small"
                  handleClickButton={this.handleReset}
                  style={{
                    color: disabled ? '#B1B3B9' : '#71737B',
                    border: 'none',
                    minWidth: 'unset',
                    width: 'unset',
                    padding: '0px 5px',
                    height: 'unset',
                  }}
                />
              )
            }
          })()}
        </div>

        <div ref={this.setContentRef} className={classes.content}>
          {this.props.toggleAttackListGeneratorDialog && isVisibleFilter('attack_list_generator', user) && (
            <AttackListGeneratorControl
              onClick={this.props.toggleAttackListGeneratorDialog}
            />
          )}

          <Section
            title="投資意欲"
            deselectAll={this.deselectAll('invest_business_area')}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="投資意欲を選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.invest_business_area)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
            {this.renderNestedList('invest_business_area', investBusinessAreaNestedMenu)}
          </Section>

          <Section
            title="導入ウェブツール"
            deselectAll={this.deselectAll('web_tool')}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="導入ウェブツールを選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.web_tool)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
            {this.renderNestedList('web_tool', webToolNestedMenu)}
          </Section>

          {isVisibleFilter('corporation_statistics_change', user) && (
            <Section
              title="企業統計情報の動向"
              deselectAll={this.deselectAll('corporation_statistics_change')}
              disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="企業統計情報の動向を選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.corporation_statistics_change)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
              {this.renderNestedList('corporation_statistics_change', corporationStatisticsChangeNestedMenu)}
            </Section>
          )}

          <div style={{ marginTop: "35px", marginBottom: "20px", width: '100%' }} onClick={() => this.handleClickPlanDialogByUserPlan(isEnableReactionKeyword(user))}>
            <GenericKeywordSearchControl
              config={KEYWORD_SEARCH_CONFIG.reaction_keyword}
              state={this.state}
              handlers={{
                handleChange: (e, property) => this.handleChange(property)(e),
                handleRadioChange: (e, property) => this.handleRadioChange(property, "and")(e),
                toggleExcludeTextField: this.toggleExcludeTextField,
              }}
              disabled={this.props.disabled}
              user={this.props.user}
              getDisabled={(config, user, disabled) => !isEnableReactionKeyword(user) || disabled}
            />
          </div>

          <CorporationDepartmentTelControl
            style={{ marginBottom: '46px' }}
            user={user}
            checked={this.state.exists_corporation_department_tels_filter}
            handleCheck={() => {
              // this.handleCheckを使うと処理が同期的にされない
              this.setState({
                exists_corporation_department_tels_filter: !this.state["exists_corporation_department_tels_filter"],
              }, () => {
                this.handleClick()
              })
            }}
            disabled={this.props.disabled}
          />
          {/* 一旦件数が少ない場合やオプションの制限など加味してオペレーターのみで表示させる */}
          {this.props.enableExecutiveListAdvancedSearch && (
            <CallAnalysisControl
              style={{ marginBottom: '46px' }}
              user={user}
              checked={this.state.include_field_call_analysis_ids}
              handleCheck={() => {
                // this.handleCheckを使うと処理が同期的にされない
                this.setState({
                  include_field_call_analysis_ids: !this.state["include_field_call_analysis_ids"],
                }, () => {
                  this.handleClick()
                })
              }}
              disabled={this.props.disabled}
            />
          )}
          <Section
            title="保存した絞り込み条件"
            disabled={this.props.disabled}
            classes={{
              sectionBody: classes.sectionBody
            }}>
            <FormControl fullWidth>
              <Select
                value={selectedFilter}
                onChange={(e) => this.props.handleFilterSelected(e.target.value)}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  }
                }}
                classes={{ select: classes.select }}
                disabled={this.props.disabled}
                fullWidth
                disableUnderline
              >
                <MenuItem key={0} value="選択してください">
                  選択してください
                </MenuItem>
                {filters.map((filter, i) => (
                  <MenuItem
                    key={i + 1}
                    value={filter.id.toString()}>
                    {filter.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography
              variant="body1"
              style={{ marginTop: '5px' }}
              onClick={this.props.toggleEditFilterDialog}
              className={classes.editFilter}>
              絞り込み条件の編集
            </Typography>
          </Section>

          <Section
            title="絞り込みオプション"
            disabled={this.props.disabled}

            classes={{
              sectionHeader: classes.sectionHeader
            }}
          >
            <div>
                {isVisibleFilter('sent_status', user) && (
                  <Submenu
                    user={user}
                    menuItems={sentStatusMenu}
                    select={this.handleSelectParent('sent_status', sentStatusMenu)}
                    set={this.state.sent_status}
                    disabled={this.props.disabled}
                    toggleDateRangePickerDialog={this.toggleSentDateRangePickerDialog}
                    selectSubmenu={this.handleSelectChild('sent_status')}
                  />
                )}
                {isVisibleFilter('corporation_sent_status', user) && (
                  <Submenu
                    user={user}
                    menuItems={corporationSentStatusMenu}
                    select={this.handleSelectParent('corporation_sent_status', corporationSentStatusMenu)}
                    set={this.state.corporation_sent_status}
                    disabled={this.props.disabled}
                    toggleDateRangePickerDialog={this.toggleCorporationSentDateRangePickerDialog}
                    selectSubmenu={this.handleSelectChild('corporation_sent_status')}
                  />
                )}
                {isVisibleFilter('follow_call_order_status', user) && (
                  <Submenu
                    user={user}
                    menuItems={followCallOrderStatusMenu}
                    select={this.handleSelectParent('follow_call_order_status', followCallOrderStatusMenu)}
                    set={this.state.follow_call_order_status}
                    disabled={this.props.disabled}
                    toggleDateRangePickerDialog={this.toggleFollowCallOrderDateRangePickerDialog}
                    selectSubmenu={this.handleSelectChild('follow_call_order_status')}
                  />
                )}
                {isVisibleFilter('download_status', user) && (
                  <Submenu
                    user={user}
                    menuItems={downloadStatusMenu}
                    select={this.handleSelectParent('download_status', downloadStatusMenu)}
                    set={this.state.download_status}
                    disabled={this.props.disabled}
                    selectSubmenu={this.handleSelectChild('download_status')}
                  />
                )}
                {isVisibleFilter('unique_per_corporation', user) && (
                  <div className={classes.entry} onClick={this.handleCheck('unique_per_corporation')}>
                    <Checkbox
                      color="primary"
                      checked={this.state.unique_per_corporation}
                      onChange={this.handleCheck('unique_per_corporation')}
                      style={{
                        width: '20px',
                        height: '20px',
                      }}
                      disabled={disabled}
                    />
                    <Typography
                      variant="subheading"
                      className={classes.text}
                      style={{ color: disabled ? '#B1B3B9' : '#181819' }}
                    >
                      企業をユニークにする
                    </Typography>
                    <ArrowToolTip
                      text="1企業につき1人をランダムで絞り込みます"
                      arrowClass={classes.arrowClass}
                      style={{ marginLeft: '2px' }}
                    >
                      <HelpIcon
                        width={16}
                        height={16}
                        color="#71737B"
                      />
                    </ArrowToolTip>
                  </div>
                )}
              <div
                className={classes.entry}
                onClick={this.handleCheck('show_recently_created')}
              >
                <Checkbox
                  color="primary"
                  checked={this.state.show_recently_created}
                  onChange={this.handleCheck('show_recently_created')}
                  style={{
                    width: '20px',
                    height: '20px',
                  }}
                  disabled={disabled}
                />
                <Typography
                  variant="subheading"
                  className={classes.text}
                  style={{ color: disabled ? '#B1B3B9' : '#181819' }}
                >
                  新任
                </Typography>
                <ArrowToolTip
                  text="新任はキーマンデータベースに更新されてから1週間以内のデータです"
                  arrowClass={classes.arrowClass}
                  style={{ marginLeft: '2px' }}
                >
                  <HelpIcon
                    width={16}
                    height={16}
                    color="#71737B"
                  />
                </ArrowToolTip>
              </div>
              {Object.entries(DAILY_NOTIFICATION_FILTER_CONFIG).map(([key]) => (
                <DailyNotificationControl
                  key={key}
                  property={key}
                  value={this.state[key]}
                  onChange={this.handleKeymanFilterChange}
                  disabled={disabled}
                />
              ))}
            </div>
          </Section>
          {this.props.enableExecutiveListAdvancedSearch && (<Section
            title="オペレーター用絞り込み"
            disabled={this.props.disabled}
            classes={{
              sectionHeader: classes.sectionHeader
            }}
          >
            {Object.entries(KL_OPERATOR_ADVANCED_SEARCH_FILTER_CONFIG).map(([key]) => (
              <KLOperatorAdvancedSearchControl
                key={key}
                property={key}
                value={this.state[key]}
                onChange={this.handleCheck(key)}
                disabled={disabled}
              />
            ))}
          </Section>)}
          {isVisibleFilter('timeline_status', user) && (<SubmenuSection
            user={user}
            title="ステータス"
            menuItems={statusMenu}
            deselectAll={this.deselectAll('timeline_status')}
            selectAll={this.selectAll('timeline_status', statusMenu)}
            select={this.handleSelectParent('timeline_status', statusMenu)}
            set={this.state.timeline_status}
            disabled={this.props.disabled}
            selectSubmenu={this.handleSelectChild('timeline_status')}
            selectSubmenuSingleSelect={this.handleSelectChildSingleSelect('timeline_status')}
          />)}

          {Object.entries(USER_LIST_FILTER_CONFIG).map(([key, config]) => (
            <Section
              key={key}
              title={config.label}
              classes={{
                sectionHeader: classes.sectionHeader
              }}
              menuItems={this.props.tags.map(tag => ({ name: tag, value: tag }))}
              selectAll={this.selectAll(key, this.props.tags.map(tag => ({ name: tag, value: tag })))}
              deselectAll={this.deselectAll(key)}
              select={this.handleSelect(key)}
              set={this.state[key]}
              disabled={this.props.disabled}
              controls={[{
                text: '管理',
                action: this.props.toggleManageTagsDialog
              }]}
            />
          ))}

          <Section title="検索ワード" disabled={this.props.disabled} tooltipText={"カタカナ・ローマ字に変えて検索すると検索結果が変わります。複数の検索ワードは空白で区切って入力してください。"} style={{ marginBottom: "15px" }}>
            {/* KEYWORD_SEARCH_CONFIGを活用した汎用キーワード検索コンポーネント */}
            {Object.values(KEYWORD_SEARCH_CONFIG)
              .filter(config => !config.key.includes('reaction') && !config.key.includes('exclude')) // reactionとexcludeキーワードをスキップ
              .map(config => (
                <div
                  key={config.key}
                  style={{ width: '100%' }}
                  onClick={config.key === 'corporate_number_keyword' ? () => this.handleClickPlanDialogByUserPlan(isEnableSearchExeByCorpNumbers(user)) : undefined}
                >
                  <GenericKeywordSearchControl
                    config={config}
                    state={this.state}
                    handlers={{
                      handleChange: (e, property) => this.handleChange(property)(e),
                      handleRadioChange: (e, property) => this.handleRadioChange(property, "and")(e),
                      toggleExcludeTextField: this.toggleExcludeTextField,
                    }}
                    disabled={this.props.disabled}
                    user={this.props.user}
                    isEnableSearchExeByCorpNumbers={isEnableSearchExeByCorpNumbers}
                  />
                </div>
              ))}
          </Section>

          <div className={classes.label} style={{ color: '#FFFFFF' }}>
            <Human width={16} height={16} color="#FFFFFF" style={{ marginRight: '5px' }} />
            キーマンの特徴から探す
          </div>

          {isVisibleFilter('cap_size_per_corporation', user) && (
            <Section
              title="表示する人数を制限"
              deselectAll={() => {
                this.deselectAll('cap_size_per_corporation')();
                this.deselectAll('cap_sort_first_preferred')();
                this.deselectAll('cap_sort_second_preferred')();
              }}
              disabled={this.props.disabled}
            >
              <Button
                type="ghost"
                text="条件を選択"
                handleClickButton={this.toggleSelectCapSizeFilterDialog}
                fullWidth={true}
                disabled={this.props.disabled}
              />
              {this.renderCapSizeFilter()}
            </Section>
          )}

          <Section
            title="部門"
            deselectAll={this.deselectAll('department')}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="部門を選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.department)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
            {this.renderNestedList('department', departmentNestedMenu)}
          </Section>

          <Section
            title="役職"
            deselectAll={this.deselectAll('honorific')}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="役職を選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.honorific)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
            {this.renderNestedList('honorific', honorificNestedMenu)}
          </Section>

          {SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG.option_menu && (
            <Section
              title={SIMPLE_MENU_FILTER_CONFIG.option_menu.category}
              classes={{
                sectionHeader: classes.sectionHeader
              }}
              menuItems={SIMPLE_MENU_FILTER_CONFIG.option_menu.menu}
              deselectAll={this.deselectAll(SIMPLE_MENU_FILTER_CONFIG.option_menu.property)}
              selectAll={this.selectAll(SIMPLE_MENU_FILTER_CONFIG.option_menu.property, SIMPLE_MENU_FILTER_CONFIG.option_menu.menu)}
              select={this.handleSelect(SIMPLE_MENU_FILTER_CONFIG.option_menu.property)}
              set={this.state[SIMPLE_MENU_FILTER_CONFIG.option_menu.property]}
              disabled={this.props.disabled}
            />
          )}

          <SubmenuSection
            title="着任"
            menuItems={relocationAtMenu}
            deselectAll={this.deselectAll('relocation_at')}
            selectAll={this.selectAll('relocation_at', relocationAtMenu)}
            select={this.handleSelectParent('relocation_at', relocationAtMenu)}
            set={this.state.relocation_at}
            disabled={this.props.disabled}
            selectSubmenu={this.handleSelectChild('relocation_at')}
            selectSubmenuSingleSelect={this.handleSelectChildSingleSelect('relocation_at')}
          />

          <Section
            title="進退"
            disabled={this.props.disabled}>
            <FormControl fullWidth>
              <Select
                value={this.state.exclude_retirement}
                onChange={this.handleChange('exclude_retirement')}
                MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  }
                }}
                classes={{ select: classes.select }}
                fullWidth
                disableUnderline
              >
                {excludeRetirementMenu.map((item, i) => (
                  <MenuItem
                    key={i}
                    value={item.value.toString()}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="body1" style={{ marginTop: '5px' }}>
              ※退任情報を公開しているデータのみ対象
            </Typography>
            <div className={classes.newLabel}>NEW</div>
            <div
              className={classes.entry}
              onClick={this.handleCheck('exclude_retirement_risk')}
            >
              <Checkbox
                color="primary"
                checked={this.state.exclude_retirement_risk}
                onChange={this.handleCheck('exclude_retirement_risk')}
                style={{
                  width: '20px',
                  height: '20px',
                }}
                disabled={disabled}
              />
              <Typography
                variant="subheading"
                className={classes.text}
                style={{ color: disabled ? '#B1B3B9' : '#181819' }}
              >
                退任リスクのキーマンを除外
              </Typography>
              <ArrowToolTip
                text="退任情報は公開されないことがあります。同一の役職のキーマンが他に就任した場合退任リスクがあるとみなします。"
                arrowClass={classes.arrowClass}
                style={{ marginLeft: '2px' }}
              >
                <HelpIcon
                  width={16}
                  height={16}
                  color="#71737B"
                />
              </ArrowToolTip>
            </div>
          </Section>

          <div className={classes.label} style={{ color: '#FFFFFF' }}>
            <Building width={16} height={16} color="#FFFFFF" style={{ marginRight: '5px' }} />
            会社の特徴から探す
          </div>

          {isVisibleFilter('fundraising', user) && (
          <Section
            title="資金調達"
            isNew={true}
            deselectAll={() => {
              this.setState(generateConfigInitialState(FUNDRAISING_FILTER_CONFIG));
            }}
            disabled={disabled}
          >
            {Object.values(FUNDRAISING_FILTER_CONFIG).map(config =>
              this.renderFundraisingFilter(config, disabled)
            )}
          </Section>
          )}

          <Section
            title="法人番号から決裁者を一括検索"
            deselectAll={() => {
              this.deselectAll('corporate_number')();
              this.deselectAll('company_name')();
            }}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="ExcelまたはCSVを選択"
              handleClickButton={this.handleUploadClick}
              fullWidth={true}
              disabled={this.props.disabled}
            />

            <input
              type="file"
              accept={SHEET_JSFT}
              onChange={this.handleFile}
              ref={(fileUpload) => { this.fileUpload = fileUpload; }}
              className={classes.input}
              onClick={e => { e.target.value = null }}
            />

            {(this.state.corporate_number.count() > 0 || this.state.company_name.count() > 0) ?
              this.renderCompany() :
              (
                <div>
                  <small className={classes.exeSearchHead}>Microsoft ExcelまたはGoogleスプレッドシートで作成した.xlsxまたは.csvに対応しています。</small>
                  <div className={classes.exeSearch}>
                    <img
                      alt="exe-search"
                      src={require('../../assets/images/image-abm-to-exe-search@2x.png')}
                      className={classes.img}
                    />
                    <p className={classes.exeSearchDesc}>
                      <span className={classes.exeSearchDescPoint}>ターゲット企業の決裁者を一括で検索します。データには<b>「法人番号」という見出しの列を含ませてください</b>。システムは、それ以降のセルを法人番号として認識します。<b>「値が欠けているセルがあると正常に検索できない可能性があります</b>のでご注意ください。</span>

                      <span className={classes.exeSearchDescPoint}>※会社名のみでも検索できますが、表記ゆれなどの理由により正確に名寄せできなかったり、検索に時間がかかったりする場合があります。あらかじめご了承ください。</span>
                    </p>

                  </div>
                </div>
              )
            }
          </Section>

          {SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG.listing_type && (
            <Section
              title={SIMPLE_MENU_FILTER_CONFIG.listing_type.category}
              classes={{
                sectionHeader: classes.sectionHeader
              }}
              menuItems={SIMPLE_MENU_FILTER_CONFIG.listing_type.menu}
              deselectAll={this.deselectAll(SIMPLE_MENU_FILTER_CONFIG.listing_type.property)}
              selectAll={this.selectAll(SIMPLE_MENU_FILTER_CONFIG.listing_type.property, SIMPLE_MENU_FILTER_CONFIG.listing_type.menu)}
              select={this.handleSelect(SIMPLE_MENU_FILTER_CONFIG.listing_type.property)}
              set={this.state[SIMPLE_MENU_FILTER_CONFIG.listing_type.property]}
              disabled={this.props.disabled}
            />
          )}

          {SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG.listing_status && (
            <Section
              title={SIMPLE_MENU_FILTER_CONFIG.listing_status.category}
              classes={{
                sectionHeader: classes.sectionHeader
              }}
              menuItems={SIMPLE_MENU_FILTER_CONFIG.listing_status.menu}
              deselectAll={this.deselectAll(SIMPLE_MENU_FILTER_CONFIG.listing_status.property)}
              selectAll={this.selectAll(SIMPLE_MENU_FILTER_CONFIG.listing_status.property, SIMPLE_MENU_FILTER_CONFIG.listing_status.menu)}
              select={this.handleSelect(SIMPLE_MENU_FILTER_CONFIG.listing_status.property)}
              set={this.state[SIMPLE_MENU_FILTER_CONFIG.listing_status.property]}
              disabled={this.props.disabled}
            />
          )}

          {/* 旧式の業界ダイアログ 新ダイアログでメイン業界のデータが揃ったら削除してOK */}
          {isVisibleFilter('jsic', user) && (
            <Section
              title="業界"
              deselectAll={this.deselectAll('jsic')}
              disabled={this.props.disabled}
            >
              <Button
                type="ghost"
                text="業界を選択"
                handleClickButton={this.toggleHierarchicalMenuDialog(MAP_MENU_CONFIG.jsic)}
                fullWidth={true}
                disabled={this.props.disabled}
              />
              {this.renderNestedList('jsic', jsicMenu)}
            </Section>
          )}

          <Section
            title="業界"
            deselectAll={this.deselectAll('industry_minor_category_ids')}
            disabled={this.props.disabled}
          >
            <Button
              type="ghost"
              text="業界を選択"
              handleClickButton={this.toggleHierarchicalMenuDialog(HIERARCHICAL_MENU_CONFIG.industry_minor_category_ids)}
              fullWidth={true}
              disabled={this.props.disabled}
            />
            {this.renderHierarchicalMenuList(HIERARCHICAL_MENU_CONFIG.industry_minor_category_ids)}
          </Section>

          {/*<SubmenuSection
            title="業界"
            menuItems={industryMenu}
            deselectAll={this.deselectAll('industry')}
            selectAll={this.selectAll('industry', industryMenu)}
            select={this.handleSelectParent('industry', industryMenu)}
            set={this.state.industry}
            disabled = {this.props.disabled}
            selectSubmenu={this.handleSelectChild('industry')}
          />*/}

          {SIMPLE_MENU_FILTER_CONFIG && SIMPLE_MENU_FILTER_CONFIG.business_type && (
            <Section
              title={SIMPLE_MENU_FILTER_CONFIG.business_type.category}
              classes={{
                sectionHeader: classes.sectionHeader
              }}
              menuItems={SIMPLE_MENU_FILTER_CONFIG.business_type.menu}
              deselectAll={this.deselectAll(SIMPLE_MENU_FILTER_CONFIG.business_type.property)}
              selectAll={this.selectAll(SIMPLE_MENU_FILTER_CONFIG.business_type.property, SIMPLE_MENU_FILTER_CONFIG.business_type.menu)}
              select={this.handleSelect(SIMPLE_MENU_FILTER_CONFIG.business_type.property)}
              set={this.state[SIMPLE_MENU_FILTER_CONFIG.business_type.property]}
              disabled={this.props.disabled}
            />
          )}

          <SubmenuSection
            title="地域"
            menuItems={prefectureNameMenu}
            deselectAll={this.deselectAll('prefecture_name')}
            selectAll={this.selectAll('prefecture_name', prefectureNameMenu)}
            select={this.handleSelectParent('prefecture_name', prefectureNameMenu)}
            set={this.state.prefecture_name}
            disabled={this.props.disabled}
            selectSubmenu={this.handleSelectChild('prefecture_name')}
            selectSubmenuSingleSelect={this.handleSelectChildSingleSelect('prefecture_name')}
          />

          {SIMPLE_MENU_FILTER_CONFIG && Object.entries(SIMPLE_MENU_FILTER_CONFIG)
            .filter(([key]) => key !== 'option_menu' && key !== 'business_type' && key !== 'listing_type' && key !== 'listing_status') // これらは既に上で処理済み
            .filter(([key]) => isVisibleFilter(key, user)) // 表示制限をチェック
            .map(([key, config]) => {
              // number_of_employeesには特別なradioControlがある
              if (key === 'number_of_employees') {
                return (
                  <Section
                    key={key}
                    title={config.category}
                    classes={{
                      sectionHeader: classes.sectionHeader
                    }}
                    menuItems={config.menu}
                    deselectAll={this.deselectAll(config.property)}
                    selectAll={this.selectAll(config.property, config.menu)}
                    select={this.handleSelect(config.property)}
                    set={this.state[config.property]}
                    disabled={this.props.disabled}
                    radioControl={
                      <IsIncludeConsolidatedControl
                        typeKey={"number_of_employees"}
                        disabled={this.props.disabled}
                        isIncludeConsolidatedSearch={this.state.is_include_consolidated_search_number_of_employees}
                        handleChange={(e, property) => this.handleRadioChange(property, "true")(e)}
                      />
                    }
                  >
                  </Section>
                );
              }
              return (
                <Section
                  key={key}
                  title={config.category}
                  classes={{
                    sectionHeader: classes.sectionHeader
                  }}
                  menuItems={config.menu}
                  deselectAll={this.deselectAll(config.property)}
                  selectAll={this.selectAll(config.property, config.menu)}
                  select={this.handleSelect(config.property)}
                  set={this.state[config.property]}
                  disabled={this.props.disabled}
                />
              );
            })}

        </div>

        <div
          className={classes.bottomMenuContainer}
        >
          <div
            className={classes.bottomMenu}
            style={{
              transform: this.hasSelection(this.props.filterValue) ? 'translateY(0%)' : 'translateY(100%)',
              visibility: this.hasSelection(this.props.filterValue) ? 'visible' : 'hidden'
            }}>
            <Button
              text="絞り込む"
              handleClickButton={this.handleClick}
              loading={this.props.isFiltering}
              fullWidth={true}
            />
          </div>
        </div>
        {this.state.showExeSearchNoMatchDialog && this.renderExeSearchNoMatchDialog()}
        {this.state.showConfirmExeSearchDialog && this.renderConfirmExeSearchDialog()}
        {this.state.showSelectCapSizeFilterDialog && this.renderSelectCapSizeFilterDialog()}
        {Object.values(MAP_MENU_CONFIG).filter(config => config.component).map(config => this.renderHierarchicalMenuDialog(config))}
        {Object.values(HIERARCHICAL_MENU_CONFIG).filter(config => config.component).map(config => this.renderHierarchicalMenuDialog(config))}
        {this.renderSentDateRangePickerDialog()}
        {this.renderCorporationSentDateRangePickerDialog()}
        {this.renderFollowCallOrderDateRangePickerDialog()}
      </div>
    );
  }
}

ExecListSidebar.propTypes = {
  classes: PropTypes.object.isRequired,
  isFiltering: PropTypes.bool,
  enableExecutiveListAdvancedSearch: PropTypes.bool,
  executiveListAdvancedSearchIpCheckLoading: PropTypes.bool,
  updateFilter: PropTypes.func.isRequired,
  filters: PropTypes.array.isRequired,
  industryCategoryList: PropTypes.array,
  selectedFilter: PropTypes.string,
  handleFilterSelected: PropTypes.func.isRequired,
  toggleEditFilterDialog: PropTypes.func.isRequired,
  togglePromotePlanChangeDialog: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  tags: PropTypes.array,
  toggleManageTagsDialog: PropTypes.func,
  user: PropTypes.object,
  togglePlanDialog: PropTypes.func,
  filterValue: PropTypes.object,
  displayNotification: PropTypes.func,
  letterOrderList: PropTypes.array,
  followCallOrderList: PropTypes.array,
  researchedTelHasDepartmentKeys: PropTypes.array,
  toggleAttackListGeneratorDialog: PropTypes.func,
};

export default withStyles(styles)(ExecListSidebar);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/ExecListSidebar.jsx